import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  currentNotification: null,
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.NOTIFICATION_ADDED: {
      const { notification } = action.payload;

      result = _.assign({}, state, {
        currentNotification: notification,
      });
      break;
    }

    case actionTypes.NOTIFICATION_SHOWN: {
      result = _.assign({}, state, {
        currentNotification: null,
      });

      break;
    }

    default: {
      result = _.assign({}, state);
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js